var _defs, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #fddce7;\n      }\n\n      .st1, .st2, .st3 {\n        fill-rule: evenodd;\n      }\n\n      .st4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st5 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st2 {\n        fill: #9d8899;\n      }\n\n      .st6 {\n        clip-path: url(#clippath);\n      }\n\n      .st3 {\n        fill: #dda6b9;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.89,23.96c.1,0,.2-.04.27-.11.07-.07.11-.17.11-.27V5.44c0-.1-.04-.2-.11-.27-.07-.07-.17-.11-.27-.11H4.38c-.1,0-.2.04-.27.11s-.11.17-.11.27v18.14c0,.1.04.2.11.27.07.07.17.11.27.11h26.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 3.98,
    y: 11.92,
    width: 27.31,
    height: 4.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.89,23.96c.1,0,.2-.04.27-.11.07-.07.11-.17.11-.27V5.44c0-.1-.04-.2-.11-.27-.07-.07-.17-.11-.27-.11H4.38c-.1,0-.2.04-.27.11s-.11.17-.11.27v18.14c0,.1.04.2.11.27.07.07.17.11.27.11h26.51Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.89,23.96c.1,0,.2-.04.27-.11.07-.07.11-.17.11-.27V5.44c0-.1-.04-.2-.11-.27-.07-.07-.17-.11-.27-.11H4.38c-.1,0-.2.04-.27.11s-.11.17-.11.27v18.14c0,.1.04.2.11.27.07.07.17.11.27.11h26.51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.45,25.12c-.42-7.14-.41-14.21,0-21.23h-3.91c.62,7.51.56,14.54,0,21.23h3.91"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.4,16.38c3.21.51,7.93-1.23,12.6-.34.4.08.8.11,1.21.11,4.89,0,9.76.1,14.61.31v-3.91c-5.25.32-10.32.46-15.24.44-.03,0-.05,0-.08,0-4.81.03-8.27-.98-13.1-1.05v4.44"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.82,15.1s-4.37-.07-6.75,1.46c0,0-7.06,5.99-10.02,7.23,0,0-1.69.45-2.34,1.31,0,0,2.86.35,3.01,1.85,0,0,1.35-2,2.56-1.78,0,0,1.62.79,4.43-1.63,0,0,3.12-3.31,4.67-3.23,0,0,2.16.11,2.44-.96,0,0,0-.01,0-.02,0,0,.37-1.29.79-2.32.23-.56.59-1.06,1.05-1.45.17-.15.31-.33.14-.47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.51,15.66c-2.03-1.06-2.19-.9-.35.13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.05,14.5s-1.18-4.96-7.36-5.66c0,0-1.46.74-2.65,3.44-.05.11-.04.24.02.35.54.88,3.35,4.86,9.37,3.82l.62-1.95"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.61,15.87s-2.78-2.8-8.06-3.46c-.04,0-.07.01-.09.04s-.02.07,0,.1c.32.49,1.38,1.93,3.28,2.79.03.02.07.03.1.05,1.89.95,4.77.46,4.77.46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.44,15.33s.84-.75.84-1.1c0,0,0-5.54,2.54-8.49.15-.18.4-.23.62-.13.84.38,2.93,1.36,3.37,1.8,0,0-.86,6.54-5.68,7.83l-.86.86-.82-.77"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.09,11.12c-.13.27-.28.54-.44.79-.87,1.33-1.28,1.8-1.71,2.21.53-2.5,1.47-5.39,3.06-6.86,0,0,.14.04.3.23.03.04.05.08.05.13,0,.61-.51,1.91-1.26,3.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.93,14.11s2.01.55,3.86,1.58c1.27.71,2.24,1.85,2.75,3.21.34.92.82,2.1,1.31,3.08.44.88,1.17,1.57,2.07,1.98.62.28,1.38.82,1.64,1.78,0,0-2.85-.46-3.41.94,0,0-2.76-1.03-3.19-2.65,0,0-.34-2.96-2.24-3.68,0,0-2.11-.49-2.08-1.6,0,0,0-.01,0-.02,0,0,0-1.34-.12-2.45-.07-.6-.27-1.18-.61-1.69-.12-.19-.2-.41,0-.49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftEnvelope);
export default __webpack_public_path__ + "static/media/giftEnvelope.242a5453c4256f4cc7a12f1240b43e5e.svg";
export { ForwardRef as ReactComponent };